import { render } from "./DisabledUsers.vue?vue&type=template&id=2a61fb4d"
import script from "./DisabledUsers.vue?vue&type=script&lang=js"
export * from "./DisabledUsers.vue?vue&type=script&lang=js"

import "./DisabledUsers.vue?vue&type=style&index=0&id=2a61fb4d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__